import { Logtail } from "@logtail/browser";

/**
 * Logtail logger instance based on current environment.
 *
 * Selects the appropriate Logtail logger for 'production', 'staging', or 'development'.
 *
 * @remarks
 * Environment is determined using process.env.NODE_ENV.
 */

type Environment = "production" | "staging" | "development";

// const getEnvironment = (): Environment => {
//   const env = process.env.NODE_ENV;
//   if (env === "production") return "production";
//   if (env === "staging") return "staging";
//   return "development";
// };

const logtailLoggers: Record<Environment, Logtail> = {
  production: new Logtail("SarHiavTBheixkLeW2k4DRf4", {
    endpoint: "https://s1302961.eu-nbg-2.betterstackdata.com",
  }),
  staging: new Logtail("9gzScSfUNP6PuGyx4BAqPtuZ", {
    endpoint: "https://s1307473.eu-nbg-2.betterstackdata.com",
  }),
  development: new Logtail("WgRHT8JBmL5RnuddgYazCzPa", {
    endpoint: "https://s1307475.eu-nbg-2.betterstackdata.com",
  }),
};

// const logtailLogger: Logtail = logtailLoggers[getEnvironment()];
const logtailLogger: Logtail = logtailLoggers["staging"];

export default logtailLogger;
